/**
 * QUANTUM STAR MARKETING — Site configuration
 * Edit anything below. Live site auto-reflects after redeploy.
 * Or visit /admin (passcode: quantum2025) to tweak in-browser.
 */

const siteConfig = {
  brand: {
    name: "Quantum Star Marketing",
    shortName: "Quantum Star",
    monogram: "Q",
    tagline: "Galactic-grade growth for ambitious brands.",
    chatbotName: "QUASAR",
  },

  contact: {
    email: "contact@qstarmarketing.com",
    phone: "+971 52 692 9145",
    address: "HC Floor, Crystal Business Center, Al Karama, Dubai, UAE",
    // Calendly booking link (live)
    bookingUrl: "https://calendly.com/contact-qstarmarketing/30min",
  },

  // WhatsApp click-to-chat
  whatsapp: {
    // International format, digits only (no + or spaces)
    number: "971526929145",
    // Default pre-filled message
    message:
      "Hi Quantum Star — I'd like to know more about your services for my business.",
  },

  social: {
    linkedin: "https://linkedin.com/",
    twitter: "https://x.com/",
    instagram: "https://instagram.com/",
    youtube: "https://youtube.com/",
  },

  hero: {
    overline: "ENTERPRISE GROWTH PARTNER",
    headlineLead: "We scale brands",
    headlineHighlight: "beyond limits",
    headlineTail: "with AI-powered growth.",
    subheadline:
      "Quantum Star Marketing engineers compounding growth for ambitious brands — fusing performance marketing, AI automation, premium branding, web development, funnels, and conversion optimization into one elite operating system.",
  },

  legal: {
    copyrightOwner: "Quantum Star Marketing",
  },
};

export default siteConfig;
